import { useEffect, useState } from "react";
import { FaPhoneAlt, FaRegClock, FaSearch } from "react-icons/fa";
import { FiEye } from "react-icons/fi";
import { FaRegCalendar } from "react-icons/fa";
import { MdSpeed } from "react-icons/md";
import { BiGasPump } from "react-icons/bi";
import { LuMessageCircle } from "react-icons/lu";
import { FaCarAlt } from "react-icons/fa";
import { FaLocationDot } from "react-icons/fa6";
import {
  getFirestore,
  collection,
  doc,
  query,
  where,
  orderBy,
  onSnapshot,
  getDoc,
} from "firebase/firestore";
import { Link, useNavigate } from "react-router-dom";
import app from "../firebase-config";
import { id_firebase } from "../content-site";
import { retiraMascara } from "../utils/retiraMascara";
import Header from "../components/Header";
import Footer from "../components/Footer";
import FiltrosAvancados from "../components/FiltrosAvancados";
import BannerCarousel from "../components/BannersCarousel";
import { formatMoney } from "../utils/formatMoney";

const firestore = getFirestore(app);

export default function Home() {
  const [veiculos, setVeiculos] = useState([]);
  const [revenda, setRevenda] = useState({});
  const [filtros, setFiltros] = useState({ marca: "", modelo: "", ano: "" });
  const [filtrosAvancados, setFiltrosAvancados] = useState({
    tipo: "",
    cor: "",
    portas: "",
    kmMax: "",
    precoMin: "",
    precoMax: "",
  });
  const [, setErroFiltro] = useState("");

  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);

    const revendaRef = doc(collection(firestore, "revenda"), id_firebase);
    getDoc(revendaRef).then((docSnap) => {
      if (docSnap.exists()) {
        setRevenda(docSnap.data());
      }
    });

    const q = query(
      collection(doc(collection(firestore, "revenda"), id_firebase), "veiculos"),
      where("veremovido", "==", 0),
      where("vevendido", "==", 0),
      orderBy("updated_at", "desc")
    );

    const unsubscribe = onSnapshot(q, (querySnapshot) => {
      const items = [];
      querySnapshot.forEach((doc) => {
        const document = doc.data();
        document.id = doc.id;
        if (document["veexibir_site"] !== false) {
          items.push(document);
        }
      });
      setVeiculos(items);
    });

    return () => unsubscribe();
  }, []);

  function getOpcoesFiltro(campo, marcaSelecionada = "") {
    const modelosFiltrados = veiculos.filter((veiculo) => {
      if (campo === "vefipe_name" && marcaSelecionada) {
        return veiculo.vefipe_marca === marcaSelecionada;
      }
      return true;
    });

    const opcoes = modelosFiltrados
      .map((veiculo) => veiculo[campo])
      .filter((valor, index, self) => valor && self.indexOf(valor) === index);

    return opcoes.sort();
  }

  const handleBuscar = () => {
    if (
      !filtros.marca &&
      !filtros.modelo &&
      !filtros.ano &&
      !Object.values(filtrosAvancados).some((value) => value)
    ) {
      setErroFiltro("Selecione pelo menos um filtro.");
      return;
    }

    const params = new URLSearchParams();
    // Mapeia os nomes dos filtros para os nomes dos campos do veículo
    if (filtros.marca) params.append("vefipe_marca", filtros.marca);
    if (filtros.modelo) params.append("vefipe_name", filtros.modelo);
    if (filtros.ano) params.append("vefipe_ano_modelo", filtros.ano);

    Object.entries(filtrosAvancados).forEach(([key, value]) => {
      if (value) {
        params.append(key, value);
      }
    });

    setErroFiltro("");
    navigate(`/estoque?${params.toString()}`);
  };

  return (
    <div className="min-h-screen w-full bg-white">
      <Header />

      <div className="flex flex-col items-center text-center sm:mt-12 space-y-2">
        <BannerCarousel />

        <div className="relative flex flex-col items-center justify-center text-black text-center px-2 sm:px-4">
          <h1 className="text-3xl sm:text-4xl md:text-6xl mt-8 font-bold mb-2 sm:mb-4">Ibiza Veículos</h1>
          <p className="text-base sm:text-lg md:text-xl mb-4 sm:mb-8">
            Desde 1992 realizando sonhos com qualidade e confiança
          </p>

          <div className="bg-white rounded-xl flex flex-col gap-2 md:gap-4 p-3 sm:p-6 shadow-lg w-full max-w-lg sm:max-w-2xl md:max-w-3xl">
            <div className="flex flex-col items-center md:flex-row gap-2 md:gap-4">
              <select
                className="p-2 rounded-md border border-gray-300 text-black w-full md:w-1/3"
                value={filtros.marca}
                onChange={e => {
                  setFiltros(f => ({ ...f, marca: e.target.value }));
                  setErroFiltro("");
                }}
              >
                <option value="">Marca</option>
                {getOpcoesFiltro("vefipe_marca").map(marca => (
                  <option key={marca} value={marca}>{marca}</option>
                ))}
              </select>

              <div className="relative w-full md:w-1/3">
                <select
                  className="p-2 rounded-md border border-gray-300 text-black w-full"
                  value={filtros.modelo}
                  onChange={e => setFiltros(f => ({ ...f, modelo: e.target.value, ano: "" }))}
                >
                  <option value="">Modelo</option>
                  {getOpcoesFiltro("vefipe_name", filtros.marca)
                    .map(modelo => (
                      <option key={modelo} value={modelo}>{modelo}</option>
                    ))}
                </select>
              </div>

              <div className="relative w-full md:w-1/3">
                <select
                  className="p-2 rounded-md border border-gray-300 text-black w-full"
                  value={filtros.ano}
                  onChange={e => {
                    setFiltros(f => ({ ...f, marca: e.target.value, modelo: "", ano: "" }));
                    setErroFiltro("");
                  }}
                >
                  <option value="">Ano</option>
                  {getOpcoesFiltro("vefipe_ano_modelo")
                    .map(ano => (
                      <option key={ano} value={ano}>{ano}</option>
                    ))}
                </select>
              </div>

              <div className="flex flex-col sm:flex-row gap-2 mt-2">
                {(filtros.marca || filtros.modelo || filtros.ano) && (
                  <button
                    className="bg-gray-200 text-gray-700 px-4 py-2 rounded-md font-semibold whitespace-nowrap w-full sm:w-auto"
                    type="button"
                    onClick={() => {
                      setFiltros({ marca: "", modelo: "", ano: "" });
                      setErroFiltro("");
                    }}
                  >
                    Limpar filtros
                  </button>
                )}

                <button
                  className="flex items-center justify-center gap-2 bg-blue-900 text-white px-4 py-2 rounded-md w-full sm:w-auto"
                  onClick={handleBuscar}
                  type="button"
                >
                  <FaSearch /> Buscar
                </button>
              </div>
            </div>

            <div className="flex justify-center mt-4">
              <div className="w-full">
                <FiltrosAvancados
                  filtros={filtrosAvancados}
                  setFiltros={setFiltrosAvancados}
                />
              </div>
            </div>
          </div>
        </div>

        <h2 className="text-xl sm:text-2xl md:text-4xl font-bold mt-18">Veículos em Destaque</h2>
        <p className="text-gray-800 text-base sm:text-xl">Selecionamos os melhores veículos com preços especiais para você</p>
      </div>


      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 mt-6 max-w-6xl mx-auto px-4">
        {veiculos
          .slice()
          .sort(() => Math.random() - 0.5)
          .slice(0, 6)
          .map((veiculo) => (
            <div key={veiculo.id} className="bg-white rounded-xl shadow-lg overflow-hidden flex flex-col">
              <img src={veiculo.imagens[0]?.fileUrl} alt={veiculo.titulo} />
              <div className="p-4 flex-1 flex flex-col justify-between">
                <h3 className="text-lg font-bold mb-2 uppercase">
                  {veiculo.vefipe_marca} {veiculo.vefipe_name}
                </h3>
                <div className="flex flex-wrap justify-between text-sm text-gray-600">
                  <span><MdSpeed /> {veiculo.vequilometragem}km</span>
                  <span><BiGasPump /> {veiculo.vefipe_combustivel}</span>
                  <span><FaRegCalendar /> {veiculo.veano_fabricacao} / {veiculo.vefipe_ano_modelo}</span>
                </div>

                <div>
                  <p className="text-xl font-bold mt-2">
                    {veiculo.vevalor ? formatMoney(veiculo.vevalor) : "Consulte o preço"}
                  </p>
                </div>

                <div className="mt-4 flex gap-2">
                  <Link to={`/veiculo/${veiculo.id}`} className="bg-blue-700 text-white px-4 py-2 rounded flex gap-2 items-center">
                    <FiEye /> Ver Detalhes
                  </Link>
                  <a
                    href={`https://api.whatsapp.com/send?phone=55${retiraMascara(revenda.petelefone2, "link")}`}
                    className="border border-gray-300 text-blue-700 font-bold px-4 py-2 rounded flex items-center"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <LuMessageCircle />
                  </a>
                </div>
              </div>
            </div>
          ))}
      </div>

      <div className="text-center mt-8">
        <Link
          className="bg-[#003c85] text-white px-6 py-3 rounded-md text-lg font-semibold inline-flex gap-2 items-center"
          to="/estoque"
        >
          <FaCarAlt /> Ver Todo o Estoque
        </Link>
      </div>

      {/* Seção de estatísticas */}
      <div className="mt-10 p-6 sm:mt-16 grid grid-cols-2 grid-rows-2 md:flex md:flex-row md:flex-wrap justify-center bg-[#003c85] text-white px-2 sm:p-10 md:p-20 gap-4 sm:gap-8 md:gap-20">
        <div className="flex flex-col items-center justify-center w-full md:w-auto">
          <h3 className="text-3xl sm:text-5xl font-bold">30+</h3>
          <p className="text-base sm:text-lg">Anos de Experiência</p>
          <p className="text-xs sm:text-sm text-gray-300">Tradição no mercado</p>
        </div>

        <div className="flex flex-col items-center justify-center w-full md:w-auto">
          <h3 className="text-3xl sm:text-5xl font-bold">5000+</h3>
          <p className="text-base sm:text-lg">Clientes Satisfeitos</p>
          <p className="text-xs sm:text-sm text-gray-300">Sonhos realizados</p>
        </div>

        <div className="flex flex-col items-center justify-center w-full md:w-auto">
          <h3 className="text-3xl sm:text-5xl font-bold">200+</h3>
          <p className="text-base sm:text-lg">Veículos em Estoque</p>
          <p className="text-xs sm:text-sm text-gray-300">Variedade garantida</p>
        </div>

        <div className="flex flex-col items-center justify-center w-full md:w-auto">
          <h3 className="text-3xl sm:text-5xl font-bold">98%</h3>
          <p className="text-base">Taxa de Aprovação</p>
          <p className="text-xs sm:text-sm text-gray-300">Satisfação garantida</p>
        </div>
      </div>

      {/* Seção sobre a loja + vídeo */}
      <div className="flex flex-col items-center text-center mt-12 sm:mt-20 space-y-2">
        <h2 className="text-xl sm:text-2xl md:text-4xl font-bold">Conheça a Ibiza Veículos</h2>
        <p className="text-gray-800 text-base sm:text-xl">Descubra nossa história e veja por que somos a melhor escolha</p>
      </div>

      <div className="flex justify-center mt-4 sm:mt-6 px-2">
        <video
          src="/video.mp4"
          autoPlay
          muted
          playsInline
          loop
          controls
          className="rounded-xl shadow-xl w-full max-w-xs sm:max-w-2xl md:max-w-3xl"
        />
      </div>

      {/* Seção de contato + mapa */}
      <section className="py-8 sm:py-12 px-2 sm:px-4 md:px-8 bg-white">
        <div className="max-w-7xl mx-auto">
          <h2 className="text-xl sm:text-2xl md:text-4xl font-bold text-center text-neutral-900 mt-10 sm:mt-20">Visite Nossa Loja</h2>
          <p className="text-center text-gray-800 text-base sm:text-xl mt-2 mb-6 sm:mb-10">
            Uma experiência completa para você encontrar o carro ideal
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 sm:gap-8 items-start">
            <div className="space-y-4 sm:space-y-6">
              <h3 className="text-lg sm:text-xl font-semibold text-neutral-800">Entre em Contato</h3>

              <div className="flex items-center gap-3 sm:gap-4 bg-white rounded-xl shadow-md p-3 sm:p-4">
                <div className="bg-blue-900 text-white p-2 sm:p-3 rounded-xl text-lg sm:text-xl">
                  <FaPhoneAlt />
                </div>
                <div>
                  <p className="font-semibold text-neutral-700">Telefone</p>
                  <p className="text-[#003c85] font-semibold">{retiraMascara(revenda.petelefone1)}</p>
                </div>
              </div>

              <div className="flex items-center gap-3 sm:gap-4 bg-white rounded-xl shadow-md p-3 sm:p-4">
                <div className="bg-blue-900 text-white p-2 sm:p-3 rounded-xl text-lg sm:text-xl">
                  <LuMessageCircle />
                </div>
                <div>
                  <p className="font-semibold text-neutral-700">WhatsApp</p>
                  <p className="text-[#003c85] font-semibold">{retiraMascara(revenda.petelefone2)}</p>
                </div>
              </div>

              <div className="flex items-start gap-3 sm:gap-4 bg-white rounded-xl shadow-md p-3 sm:p-4">
                <div className="bg-blue-900 text-white p-2 sm:p-3 rounded-xl text-lg sm:text-xl">
                  <FaLocationDot />
                </div>
                <div>
                  <p className="font-semibold text-neutral-700">Endereço</p>
                  <p className="text-neutral-600">
                    {revenda.peendereco_fiscal}, {revenda.peendereco_fiscal_numero} – {revenda.pebairro_fiscal}
                  </p>
                  <p className="text-neutral-600">{revenda.pecidade} – {revenda.peuf}</p>
                </div>
              </div>

              <div className="flex items-start gap-3 sm:gap-4 bg-white rounded-xl shadow-md p-3 sm:p-4">
                <div className="bg-blue-900 text-white p-2 sm:p-3 rounded-xl text-lg sm:text-xl">
                  <FaRegClock />
                </div>
                <div>
                  <p className="font-semibold text-neutral-700">Horário</p>
                  <p className="text-neutral-600">Segunda à Sexta: 8:00 às 18:00</p>
                  <p className="text-neutral-600">Sábado: 8:00 às 12:00</p>
                </div>
              </div>
            </div>

            <div>
              <iframe
                className="w-full h-64 sm:h-[400px] rounded-xl shadow-md"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3781.4697863907577!2d-46.5146187!3d-18.5979279!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x94aef534dd6ce9a5%3A0x43a50817fdb9d433!2sIbiza%20Ve%C3%ADculos!5e0!3m2!1spt-BR!2sbr!4v1751310841918!5m2!1spt-BR!2sbr"
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Mapa da Loja"
              ></iframe>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
